<div class="container bg3 page-keyword"
     #container
     (scroll)="onScroll($event)">

  <app-header showJasoIdx="true"
              placeholder="검색어를 입력 해 보시오."
              [curJasoIdx]="curJasoIdx"
              [secondJaso]="false"
              [keyHistory]="HISTORY_KEY_SEARCH_HOMONYM"
              (search)="onSearch($event)"></app-header>
  <!-- (search)="ReloadList($event)"></app-header> -->

  <app-left-menu></app-left-menu>

  <section class="same-list {{ showDetail ? 'overlay' : '' }}" style="">
    <div class="inner wrap">
      <div class="same-wrap">
        <div class="list-wrap2">
          <div *ngIf="ll.getTotalCount() === 0"
               class="keyword-item-box">
            <div class="img-box">
              <img src="assets/img/img_menu_tiger.svg">
            </div>
            <div class="keyword-no-result-box">
              이운이의어가 없습니다.
            </div>
          </div>

          <ul>
            <li>
              <app-homonym2-list-item *ngFor="let homonym of ll?.getList(); let idx = index"
                                      [homonym]="homonym"
                                      (click)="onSelectItem($event, homonym)">
              </app-homonym2-list-item>
            </li>
          </ul>

          <div class="reload-icon" *ngIf="!ll.IsComplete()">
            <!-- button (click)="onClickReload()"><img #reload src="assets/img/loading_icon.gif"></button -->
            <img #reload src="assets/img/loading_icon.gif">
          </div>

        </div>
      </div>
    </div>
  </section>


  <app-homonym-detail *ngIf="showDetail"
                      class="word-detail keyword-detail type-same"
                      [homonym]="curHomonym"
                      (openHelp)="OpenHelp()"
                      (closeDetail)="onCloseItem()"></app-homonym-detail>

  <app-footer></app-footer>

  <!-- popup -->
  <article class="popup popup-help"
           *ngIf="lm.showHelp" [@wordDetailInOut]>
    <app-word-help (closePopup)="CloseHelp()"></app-word-help>
  </article>

  <article class="popup popup-help"
           *ngIf="lm.showPitchHelp" [@wordDetailInOut]>
    <app-pitch-help-popup (closePopup)="ClosePitchHelp()"></app-pitch-help-popup>
  </article>

</div>

<app-common-popups></app-common-popups>
